<template>
    <div class="card-body">
        <div class="row">
            <!-- Plan -->
            <div v-for="plan in plans" :key="plan.id" class="col-md-3 py-4 mb-4 mb-md-0">
                <h5 class="mb-3 font-weight-bold">
                    {{ __('payments.' + plan.name) }}
                </h5>
                <h1 class="font-weight-bold">
                    USD {{ plan.monthly_price }}
                </h1>
                <p>
                    {{ __('payments.prc_pormes' ) }}
                </p>
                <p>
                    {{ __('payments.' + plan.description) }}
                </p>
                <p>
                    {{ __('payments.Total Price') }} <b>USD {{ plan.value }}</b>
                </p>

                <p class="mt-4">
                    <button @click="selectPlan(plan.id)" class="btn btn-success btn-outline">{{ __('payments.Select Plan') }}</button>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['plans'],
    data() {
        return {}
    },
    methods: {
        selectPlan(id) {
            this.$emit('setPlan', id);
        }
    }
}
</script>
